<template>
  <div>
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="5">
          <h2>Ingressos</h2>

          <div v-if="batchesOptions.length === 0" class="mb-3">
            Nenhum lote disponível no momento.
          </div>

          <div v-if="batchesOptions.length !== 0">
            <b-form @submit.prevent="false">
              <b-form-group
                label="Escolha um lote:">

                  <b-form-radio-group
                    v-model="form.batchId"
                    :options="batchesOptions"
                    stacked>
                  </b-form-radio-group>
              </b-form-group>

              <b-form-group
                class="mt-4"
                v-if="batchChosen" label="Informe a quantidade:">

                <b-input-group prepend="Quantidade:">
                  <b-form-input
                    v-model="form.quantity"
                    type="number"
                    value="1">
                  </b-form-input>
                  <b-input-group-append>
                    <b-btn @click="incrementQuantity">
                      <icon scale="1" name="plus"></icon>
                    </b-btn>
                    <b-btn @click="decrementQuantity">
                      <icon scale="1" name="minus"></icon>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>

                <b-btn
                  class="mt-4"
                  variant="success"
                  @click="createTickets(form.dealerId, form.batchId, form.quantity)">
                    Imprimir
                </b-btn>
              </b-form-group>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'DealerCreateTickets',
  data () {
    return {
      dealer: '',
      batches: [],
      form: {
        batchId: null,
        quantity: 1
      }
    }
  },
  created () {
    this.dealer = this.$route.params.dealer
    this.getEvent()
  },
  methods: {
    getEvent () {
      let url = process.env.VUE_APP_URL_APP + '/b/dealers/' + this.dealer + '/events'

      return this.$http.get(url).then(res => {
        if (res.body.batches.length > 0) {
          this.batches = this.$_.orderBy(res.body.batches, ['id'], ['asc'])
        }
      }, err => {
        console.log(err)
      })
    },
    incrementQuantity () {
      this.form.quantity++
    },
    decrementQuantity () {
      if (this.form.quantity > 1) {
        this.form.quantity--
      }
    },
    createTickets (dealerId, batchId, quantity) {
      let route = this.$router.resolve({
        name: 'DealerRenderTickets',
        params: {
          dealer: this.dealer,
          batch: batchId,
          quantity: quantity
        }
      })
      this.form.quantity = 1
      window.open(route.href, '_blank')
    }
  },
  computed: {
    batchesOptions () {
      let ab = this.$_.filter(this.batches, b => b.is_available === 1)
      return this.$_.map(ab, b => {
        return {text: b.name, value: b.id}
      })
    },
    batchChosen () {
      return this.form.batchId !== null
    }
  }
}
</script>
